import ColorGroup from "@/app/(site)/_components/SanityGroups/ColorGroup"
import ImageGroup from "@/app/(site)/_components/SanityGroups/ImageGroup"
import VideoGroup from "@/app/(site)/_components/SanityGroups/VideoGroup"
import { type MediaGroupContentType } from "@/gc-sanity-types"

export interface MediaGroupProps {
    className?: string
    isAboveTheFold?: boolean
}
interface MediaGroupComponentProps extends MediaGroupProps {
    media: MediaGroupContentType
    imageSizes?: string
    objectSetting?: string
}

export default function MediaGroup({
    className,
    isAboveTheFold,
    media,
    imageSizes,
    objectSetting
}: MediaGroupComponentProps) {
    if (media?.imageGroup?.images[0]) {
        return (
            <ImageGroup
                image={media.imageGroup?.images[0]}
                className={className}
                isAboveTheFold={isAboveTheFold}
                sizes={imageSizes}
                objectSetting={objectSetting}
            />
        )
    }

    if (media?.videoGroup?.videos.length) {
        return <VideoGroup videos={media.videoGroup?.videos} className={className} />
    }

    if (media?.colorGroup) {
        return <ColorGroup color={media.colorGroup || ""} className={className} />
    }

    return null
}
